/**
 * Generates the Chakra v3 system config for a brand as plain data, so this
 * package stays dependency-free. Frontends apply it with:
 *
 *   createSystem(defaultConfig, brandThemeConfig(getBrand()))
 */
export function brandThemeConfig(brand) {
    const scale = Object.fromEntries(Object.entries(brand.colors.primary).map(([shade, value]) => [shade, { value }]));
    return {
        theme: {
            tokens: {
                fonts: {
                    heading: { value: brand.fonts.heading },
                    body: { value: brand.fonts.body },
                },
                colors: {
                    primary: scale,
                    brand: {
                        accent: { value: brand.colors.accent },
                        headerBg: { value: brand.colors.headerBg },
                        footerBg: { value: brand.colors.footerBg },
                        pageBg: { value: brand.colors.pageBg },
                        text: { value: brand.colors.text },
                    },
                },
            },
            semanticTokens: {
                colors: {
                    primary: {
                        solid: { value: '{colors.primary.500}' },
                        contrast: { value: 'white' },
                        fg: { value: '{colors.primary.700}' },
                        muted: { value: '{colors.primary.100}' },
                        subtle: { value: '{colors.primary.50}' },
                        emphasized: { value: '{colors.primary.600}' },
                        focusRing: { value: '{colors.primary.500}' },
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=theme.js.map